import { render, staticRenderFns } from "./EcommerceCardWebsiteStatistics.vue?vue&type=template&id=42da40e3&scoped=true&"
import script from "./EcommerceCardWebsiteStatistics.vue?vue&type=script&lang=js&"
export * from "./EcommerceCardWebsiteStatistics.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceCardWebsiteStatistics.vue?vue&type=style&index=0&id=42da40e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42da40e3",
  null
  
)

export default component.exports